/**
 * Displays a notification toast message on the screen.
 *
 * @param {string} [header=''] - The header text to display in the toast.
 * @param {string} [message=''] - The message text to display in the toast.
 *
 * The toast is styled as a fixed-position element and appears at the bottom center of the screen.
 * Multiple toasts are stacked in reverse order with spacing between them.
 * The toast automatically disappears after 30 seconds unless manually closed by the user.
 *
 * @example
 * // Display a notification with a header and message
 * notify('Success', 'Your changes have been saved.');
 *
 * @example
 * // Display a notification with only a message
 * notify('', 'This is a message without a header.');
 */
function notify(header, message, iconID) {
    var toastId = 'toast-' + new Date().getTime();
    var currentTconID = iconID || 'success'
    header = header || '';
    message = message || '';
    var iconSvgs = {
        'success': `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10.5575 16.8825L17.8195 9.62078L16.038 7.82503L10.5575 13.3055L7.87728 10.625L6.09578 12.4208L10.5575
                    16.8825ZM12 22.4805C10.5414 22.4805 9.17545 22.2059 7.90228 21.6565C6.62928 21.1072 5.52195 20.3616 4.58028
                    19.4198C3.63845 18.4781 2.89286 17.3708 2.34353 16.0978C1.7942 14.8246 1.51953 13.4587 1.51953 12C1.51953 10.5414
                    1.7942 9.17545 2.34353 7.90228C2.89286 6.62928 3.63845 5.52195 4.58028 4.58028C5.52195 3.63845 6.62928 2.89286
                    7.90228 2.34353C9.17545 1.7942 10.5414 1.51953 12 1.51953C13.4587 1.51953 14.8246 1.7942 16.0978 2.34353C17.3708
                    2.89286 18.4781 3.63845 19.4198 4.58028C20.3616 5.52195 21.1072 6.62928 21.6565 7.90228C22.2059 9.17545 22.4805
                    10.5414 22.4805 12C22.4805 13.4587 22.2059 14.8246 21.6565 16.0978C21.1072 17.3708 20.3616 18.4781 19.4198
                    19.4198C18.4781 20.3616 17.3708 21.1072 16.0978 21.6565C14.8246 22.2059 13.4587 22.4805 12 22.4805Z"
                    fill="#0A0A0A"/>
                </svg>`,
        'warning': `<svg width="24" height="24" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g id="Size=L, Fill=Off">
                        <path id="Union" d="M1.37793 42.3675L23.9999 3.26498L46.6219 42.3675H1.37793ZM7.73693 38.689H40.2629L23.9999 10.5935L7.73693 38.689ZM24.2089 36.0935C24.6473 36.0935 25.0241 35.9328 25.3394 35.6115C25.6551 35.2898 25.8129 34.9098 25.8129 34.4715C25.8129 34.0332 25.6523 33.661 25.3309 33.355C25.0093 33.0487 24.6293 32.8955 24.1909 32.8955C23.7526 32.8955 23.3758 33.0515 23.0604 33.3635C22.7448 33.6755 22.5869 34.0506 22.5869 34.489C22.5869 34.9273 22.7476 35.3043 23.0689 35.62C23.3906 35.9356 23.7706 36.0935 24.2089 36.0935ZM22.6999 30.6H25.6999V19.626H22.6999V30.6Z" fill="#fff"/>
                    </g>
                    </svg>`
    }

    var toastHTML = `<div id="${toastId}"
    class="toast-container d-flex p-3 bg--grey-80 color--white show opacity-100 rounded-lg justify-content-start align-items-center ecux-notify"
    role="alert" aria-live="assertive" aria-atomic="true" style="position: fixed; bottom: 20px; left: 50%; transform: translateX(-50%); z-index: 1060;">
        <div class="d-flex col-2 p-0 h-100 justify-content-center align-items-center">
            <div class="icon icon-check-circle --icon-${currentTconID} --icon-md">
                ${iconSvgs[currentTconID]}
            </div>
        </div>
        <div class="col-10 p-0">
            <div class="toast-header bg--grey-80 color--white p-0">
                <strong class="mr-auto color--white sub-title-sm font-bold">${header}</strong>
                <button type="button" class="ml-2 mb-1 font-bold text-lg color--white opacity-1" data-dismiss="toast" aria-label="Close"
                    onclick="document.getElementById('${toastId}').remove();"> <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="toast-body py-0 pl-0 max-w-80">${message}</div>
            </div>
    </div>`;

    document.body.insertAdjacentHTML('beforeend', toastHTML);

    // Adjust position of all toasts to stack them in reverse order
    var toasts = Array.from(document.querySelectorAll('[id^="toast-"]')).reverse();
    toasts.forEach((toast, index) => {
        toast.style.bottom = `${3 + index * 10}rem`; // Adjust spacing between toasts
    });

    // Automatically remove the toast after 30 seconds
    setTimeout(() => {
        var toastElement = document.getElementById(toastId);
        if (toastElement) {
            toastElement.remove();
        }
    }, 10000);
}

module.exports = notify;
